<div
  class="auth-wrapper"
  [class]="asideData?.baseClass"
>
  <div class="auth-wrapper-container">
    <div class="auth-actions">
      <base-language-switch
        [color]="colors.white"
        class="auth-wrapper-language-switch ms-3"
      ></base-language-switch>
      <div class="d-flex justify-content-start justify-content-md-end flex-wrap gap-2">
        <base-contact-button class="auth-contact"></base-contact-button>
        <base-button
          (btnClick)="goTo(baseStazzleLinks.IMPRINT)"
          [size]="buttonSize.sm"
          label="imprint"
          color="white"
        ></base-button>
        <base-button
          *ngIf="!isRegisterPage"
          (btnClick)="goTo(baseStazzleLinks.PRIVACY_POLICY)"
          [size]="buttonSize.sm"
          label="privacyPolicy"
          color="white"
        ></base-button>
      </div>
    </div>

    <div class="auth-form d-flex flex-column align-items-center justify-content-center">
      <div class="auth-intro text-center">
        <img
          class="img-fluid"
          [src]="logo"
          alt="stazzle Logo"
        />
        <h2 class="m-0">
          {{ asideData?.description | translate }}
        </h2>
      </div>
      <div class="d-flex justify-content-center align-items-center w-100 px-3">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
